import {observer} from "mobx-react-lite";
import GameStore from "../../store/game";

// Компактный список прошлых попыток
export const GameBoard = observer(() => {
    // Показываем завершенные попытки и текущий ввод, если игра активна.
    const completedAttempts = (GameStore.attemptHistory || [])
        .slice(0, GameStore.attemptNumber)
        .filter(Boolean);
    const attempts = (GameStore.isActive && GameStore.attempt.length > 0)
        ? [...completedAttempts, GameStore.attempt]
        : completedAttempts;

    const getLetterStatus = (cell) => {
        if (!cell) return "idle";
        const isExact = cell.is_exactly_exists === true || cell.isExactlyExists === true;
        const isExists = cell.is_exists === true || cell.isExists === true;
        if (isExact) return "exact";
        if (isExists) return "exists";
        return cell.value ? "miss" : "idle";
    };

    const statusClasses = {
        exact: "bg-lime-500 text-gray-900 border-lime-200",
        exists: "bg-white text-gray-900 border-white",
        miss: "bg-gray-700 text-gray-300 border-gray-600",
        idle: "bg-gray-800 text-gray-200 border-yellow-100/50",
    };

    if (attempts.length === 0) {
        return (
            <div className="px-4 py-2 text-sm text-gray-400 text-center">
                Your attempt will appear here after word input
            </div>
        );
    }

    return (
        <div className="px-4 py-2 flex flex-col gap-2 w-full">
            {attempts.map((history, rowIndex) => (
                <div className="flex gap-1 sm:gap-1.5 justify-center" key={`row-${rowIndex}`}>
                    {history.map((cell, colIndex) => {
                        const value = cell?.value ?? "";
                        const status = getLetterStatus(cell);
                        const tileClasses = [
                            "w-8 h-8 sm:w-9 sm:h-9 lg:w-10 lg:h-10 rounded-lg border flex items-center justify-center text-base sm:text-lg uppercase transition-transform duration-150",
                            statusClasses[status],
                        ].join(" ").trim();

                        return (
                            <div className={tileClasses} key={`tile-${rowIndex}-${colIndex}`}>
                                {value}
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
});
